import { z } from 'zod';
const mobilizeMissionParamsSchema = z.object({
    missionId: z.string().uuid(),
});
export const mobilizeMissionFunctionDef = {
    name: 'mobilizeMission',
    requestSchema: mobilizeMissionParamsSchema,
    responseSchema: z.void(),
};
